import * as Yup from 'yup';

export type BalanceAdjustmentFormType = {
  date: Date | null;
  tempDate: Date | null;
  needApproval: boolean;
  balanceableId: string | null;
  type: string | null;
  amount: number;
  userType?: string;
  description: string;
  balance: number;
  number?: string;
  refId?: string;
};

export const balanceAdjustmentSchema = () =>
  Yup.object()
    .shape({
      date: Yup.date().nullable().required(),
      balanceableId: Yup.string().required(),
      userType: Yup.string().required(),
      type: Yup.string().required(),
      amount: Yup.number()
        .transform((value) => (isNaN(value) ? undefined : value))
        .min(0)
        .required(),
      description: Yup.string().nullable(),
      refId: Yup.string(),
    })
    .required();
